export default __webpack_public_path__ + "static/media/java.7f7b1d06.png";